import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import SmartphoneIcon from "@mui/icons-material/Smartphone";

export default function PreviewModal({ open, html, onClose }) {
  const [device, setDevice] = useState("desktop");
  const width = device === "mobile" ? 375 : 700;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        Preview
        <div style={{ display: "inline-block", marginLeft: 16 }}>
          <ToggleButtonGroup
            size="small"
            exclusive
            value={device}
            onChange={(_e, v) => v && setDevice(v)}
          >
            <ToggleButton value="desktop">
              <DesktopWindowsIcon fontSize="small" />
            </ToggleButton>
            <ToggleButton value="mobile">
              <SmartphoneIcon fontSize="small" />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ backgroundColor: "#f5f7f9" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <iframe
            title="email-preview"
            srcDoc={html}
            style={{
              width,
              maxWidth: "100%",
              height: "70vh",
              border: "1px solid #e0e0e0",
              borderRadius: 8,
              background: "#fff",
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
